import React from 'react';
import informationLine from '../../assets/images/information-line.svg';

import './styles.css';

// NOTE: trigger main build

const NewOpenedAccountBanner = ({ isMobile = false }) => (
  <div styleName="bannerRow" justify="center">
    <div styleName={`bannerCol ${isMobile ? 'mobile' : ''}`}>
      <img
        src={informationLine}
        alt="Information Line"
      />
      <span>
        If you opened an account after 2/6/2023, please visit{' '}
        <a href="https://www.myipo.com/" target="_blank" rel="noopener noreferrer">
          www.myipo.com
        </a>{' '}
        to access your account information, including cash balances and investment holdings.
      </span>
    </div>
  </div>
);


export default NewOpenedAccountBanner;



// WEBPACK FOOTER //
// ./src/components/NewOpenedAccountBanner/index.js